// API Configuration
// Centralized API base URL for all fetch/axios calls

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://paranaque-web-system.onrender.com';

export default API_BASE_URL;
